import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SecondaryButton } from '@components/button/secondary-button/secondary-button';
import { MatrixGroupKey } from '../../data-monitoring-matrix.util';
import { BoardView } from '../../data-monitoring-view.model';

/**
 * The month board of the data monitoring matrix: legend, month pager, calendar grid, rules.
 * A calendar grid (sticky label column, one column per day) is not a list, so it is not an `app-data-table`.
 */
@Component({
  selector: 'app-data-monitoring-board',
  standalone: true,
  imports: [TranslateModule, SecondaryButton],
  templateUrl: './data-monitoring-board.html',
  styleUrl: './data-monitoring-board.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataMonitoringBoardComponent {
  readonly view = input.required<BoardView>();
  readonly monthNameKey = input.required<string>();
  readonly year = input.required<number>();
  readonly isFirstMonth = input(false);
  readonly isLastMonth = input(false);
  readonly forecastDays = input.required<number>();
  readonly forecastHorizon = input.required<number>();

  readonly previousMonth = output<void>();
  readonly nextMonth = output<void>();
  readonly toggleGroup = output<MatrixGroupKey>();
}
